module.exports = __webpack_public_path__ + "media/images/qr/narrative-qr-colour-827355b3b1fb08023cb7a9ddf9666487.svg";